export default __webpack_public_path__ + "static/media/problema-01.01e9d38f.webp";